import axios from 'axios';
import { useMutation, UseMutationOptions } from './useMutation';
import { useApp } from '../designs/paper/context/AppContext';
import {
  CartSessionResponse,
  StartReservationDraftParams,
} from '../../../../../shared/types/cartSession';

type UseStartReservationOptions = UseMutationOptions<
  CartSessionResponse,
  Error,
  StartReservationDraftParams
>;

/**
 * Hook to start a new reservation (create reservation draft and cart session)
 * @param options - Mutation options
 */
export function useStartReservation(options?: UseStartReservationOptions) {
  const { config } = useApp();

  return useMutation<CartSessionResponse, Error, StartReservationDraftParams>(async params => {
    const response = await axios.post<CartSessionResponse>(config.startReservationUrl, params);
    return response.data;
  }, options);
}
